import React, {useCallback, useEffect, useMemo} from 'react'
import * as R from "ramda";
import {GroupBox} from "../field/groupbox";
import {FlexGrid} from "../../grid";
import {Tabs} from "../field/tabs";
import {
    TextInput,
    TextArea,
    Wysiwyg,
    ReactSelect,
    ExtServiceType,
    Checkbox,
    Radiobox,
    RadioboxCards,
    Image,
    Images,
    OfferUrl,
    WhitePageSettings,
    MultilangBox,
    Comments,
    Pixels,
    Files,
    CodeMirror,
    DateTime,
    DateTimeRange,
    PushNotificationSubscribeRequest,
    PushNotificationFirstTime,
    ActiveItems,
    PushNotificationPeriodPeriodically,
    PushNotificationPeriodOnce, PushNotificationPeriodByAction, PushNotificationPeriod, PrelandSettings,
} from './fields'
import {InfoBox} from "../field/infobox";
import {CloneNewAppsDetailsBlock} from "./fields/clone.newapps.details";
import {Trans, useTranslation } from "react-i18next"
import i18next from 'i18next'
import {GridContentBox, InfoBlock} from "../app/field/InfoBlock";
import {EAppGeneral, EAppLanding, EAppTracking} from "../../../enums";

// import {Select} from "./field/selects";

export function getItemDefaultValue(item, initialValues){
    //let defaultValue = ( initialValues && R.path(item.name.split('.'), initialValues) && initialValues[item.name] ) || item.defaultValue;
    // let defaultValue = initialValues[item.name] || R.path(item.name.split('.'), initialValues) || item.defaultValue;
    let defaultValue = initialValues[item.name+'_raw'] || R.path((item.name+'_raw').split('.'), initialValues)
    // console.log('defaultValue', item.name, defaultValue);
    // if(!defaultValue && defaultValue !== false) defaultValue = initialValues[item.name] || R.path(item.name.split('.'), initialValues);
    if (defaultValue === undefined) {
        defaultValue = initialValues[item.name] || R.path(item.name.split('.'), initialValues)
    }
    // console.log('defaultValue2', item.name, defaultValue);
    // if(!defaultValue && defaultValue !== false) defaultValue = item.defaultValue;
    if (defaultValue === undefined) {
        defaultValue = item.defaultValue;
    }

    if (item.type === 'checkbox') {
        defaultValue = defaultValue && (defaultValue === true || defaultValue === 'true' || parseInt(defaultValue) === 1) ? 1 : 0;
    }

    return defaultValue;
}

export default function getField(
    formFieldProps,
    errors,
    initialValues,
    item,
    i,
    itemNamePrefix = ''
){
    // console.log('initialValues', {formFieldProps: { ...formFieldProps }, 'item.name': item.name, itemNamePrefix});

    if (item.autoTranslate === undefined || !!item.autoTranslate) {
        if (item.label && typeof item.label === 'string') {
            item.label = i18next.t(item.label)
        }
        if (item.placeholder && typeof item.placeholder === 'string') {
            item.placeholder = i18next.t(item.placeholder)
        }
        if (item.hint && typeof item.hint === 'string') {
            item.hint = i18next.t(item.hint)
        }
        if (item.defaultValue && typeof item.defaultValue === 'string') {
            item.defaultValue = i18next.t(item.defaultValue)
        }
        if (item.defaultValue && typeof item.defaultValue?.label === 'string') {
            item.defaultValue.label = i18next.t(item.defaultValue.label)
        }
        if (item.defaultValue && typeof item.defaultValue?.value === 'string') {
            item.defaultValue.value = i18next.t(item.defaultValue.value)
        }
        if (item.options && Array.isArray(item.options) && item.options.length) {
            item.options = item.options.map((option) => {
                const { label, value } = option
                const l = typeof label === 'string'
                const v = typeof value === 'string'
                return {
                    ...option,
                    label: l ? i18next.t(label) : label,
                    value: v ? i18next.t(value) : value,
                }
                
            })
        }
    }

    item.name = item.origname || item.name;
    // console.log('item.name', item.name, item.origname, itemNamePrefix);

    if (item.name) {
        item.name = `${itemNamePrefix}${item.name}`;
        let splitedName = item.name.split('.');
        formFieldProps.key = `${item.name}-${i}`;
        formFieldProps.error = R.path(splitedName, errors) || errors[item.name];
        // formFieldProps.defaultValue = ( initialValues && R.path(item.name.split('.'), initialValues) && initialValues[item.name] ) || item.defaultValue;
        formFieldProps.defaultValue = getItemDefaultValue(item, initialValues);
        // formFieldProps.defaultValue = initialValues[item.name] || R.path(item.name.split('.'), initialValues) || item.defaultValue;
        // if(item.type === 'checkbox')
        //     formFieldProps.defaultValue = formFieldProps.defaultValue && (formFieldProps.defaultValue === true || formFieldProps.defaultValue === 'true' || parseInt(formFieldProps.defaultValue) === 1) ? 1 : 0;
    } else {
        formFieldProps.key = `${item.label || item.type}-${i}`;
        formFieldProps.defaultValue = '';
    }
    formFieldProps.fieldProps = item;
// console.log('errors', errors);
// console.log('formFieldProps', formFieldProps);

    if (item.type === 'render') return item?.render?.(item, formFieldProps) ?? <span style={{ color: 'red' }}>??? item.render ???</span>
    if (item.type === 'text') return <TextInput {...formFieldProps} />
    if (item.type === 'number') return <TextInput {...formFieldProps} />
    if (item.type === 'checkbox') return <Checkbox {...formFieldProps} />
    if (item.type === 'radiobox') return <Radiobox {...formFieldProps} />
    if (item.type === 'radioboxcards') return <RadioboxCards {...formFieldProps} />

    // if (item.type === 'select') {
    //     return (
    //         <Select key={item.name+' '+i}
    //                   {...item}
    //                   errorMessage={errors[item.name] ? errors[item.name].message : ''}
    //         />
    //     )
    // }
    if (item.type === 'reactselect') return <ReactSelect {...formFieldProps} />
    if (item.type === 'textarea') return <TextArea {...formFieldProps} />
    if (item.type === 'wysiwyg') return <Wysiwyg {...formFieldProps} />
    if (item.type === 'image') return <Image {...formFieldProps} />
    if (item.type === 'images') return <Images {...formFieldProps} />
    if (item.type === 'files') return <Files {...formFieldProps} />
    if (item.type === 'codemirror') return <CodeMirror {...formFieldProps} />
    if (item.type === 'extservicetype') return <ExtServiceType {...formFieldProps} />
    if (item.type === 'offerurl') return <OfferUrl {...formFieldProps} />
    if (item.type === 'whitepage_settings') return <WhitePageSettings {...formFieldProps} />
    if (item.type === 'preland_settings') return <PrelandSettings {...formFieldProps} />
    if (item.type === 'push_period') return <PushNotificationPeriod {...formFieldProps} />
    if (item.type === 'push_period_periodically') return <PushNotificationPeriodPeriodically {...formFieldProps} />
    if (item.type === 'push_period_once') return <PushNotificationPeriodOnce {...formFieldProps} />
    if (item.type === 'push_period_byaction') return <PushNotificationPeriodByAction {...formFieldProps} />
    if (item.type === 'push_subscriberequest') return <PushNotificationSubscribeRequest {...formFieldProps} />
    if (item.type === 'push_firsttime') return <PushNotificationFirstTime {...formFieldProps} />
    if (item.type === 'multilangbox') return <MultilangBox {...formFieldProps} />
    if (item.type === 'comments') return <Comments {...formFieldProps} />
    if (item.type === 'pixels') return <Pixels {...formFieldProps} />
    if (item.type === 'datetime') return <DateTime {...formFieldProps} />
    if (item.type === 'datetimerange') return <DateTimeRange {...formFieldProps} />
    if (item.type === 'activeitems') return <ActiveItems {...formFieldProps} />
    if (item.type === 'clonenewappsdetails') return <CloneNewAppsDetailsBlock {...formFieldProps} />
    if (item.type === 'infobox') return <InfoBox key={formFieldProps.key || `infobox-${i}`} {...item} />
    if (item.type === 'groupbox') return (
        <GroupBox key={formFieldProps.key || `groupbox-${i}`} {...item}>
            {item.fields?.map((boxItem, i) => {
                return getField(formFieldProps, errors, initialValues, {...boxItem}, i, itemNamePrefix);
            })}
        </GroupBox>
    )
    if (item.type === 'flexgrid') return (
        <FlexGrid key={formFieldProps.key || `flexgrid-${i}`}
                  {...item}
                  columns={item.columns?.map(({fields, className, ...rest}, idx, allColumns)=>{
                      return {
                          ...rest,
                          // className: `py-2 px-2 ${className}`,
                          className: `${className}`,
                          content: fields.map((_field, idx, allColumns)=>{
                              return getField(formFieldProps, errors, initialValues, {..._field}, i, itemNamePrefix);
                          }),
                      };
                  })}
        />
    )
    if (item.type === 'tabs') return (
        <Tabs key={formFieldProps.key || `tabs-${i}`} {...item}
              tabs={item.tabs?.map(({content, ...rest}, idx, allColumns)=>{
                  return {
                      ...rest,
                      content: <> {content.map((_field, idx, allColumns)=>{
                          return getField(formFieldProps, errors, initialValues, {..._field}, idx, itemNamePrefix);
                      })}</>,
                  };
              })}  />
    )
    if (item.type === 'filtersPanel') {
        //according to the implementation; check src/components/form/formgen2/index.js
        return (
          <div>
              <h1 style={{color: `var(--it-text-red)`}}>{`getField usage for type='${item.type}' is NOT valid. Check 'isFiltersPanel={true}' to be used in FormGen (FilterComponent)`}</h1>
          </div>
        )
    }

    if ([
        ...Object.values(EAppLanding),
        ...Object.values(EAppTracking),
        ...Object.values(EAppGeneral),
    ].includes(item.type)) {
        const blockTitleStyles = item?.blockTitleStyles ?? {};
        const blockContentStyles = item?.blockContentStyles ?? {};

        return (
          <InfoBlock key={formFieldProps.key || `info-block-${item.type}-${i}`}
                     title={item?.blockTitle}
                     icon={item?.blockTitleIcon}
                     styleHeader={blockTitleStyles}
                     styleContent={blockContentStyles}
                     withFlexWrapper={false}
          >
              <FlexGrid {...item}
                        className={'w-full flex-wrap'}
                        columns={item.columns?.map(({fields, className, ...rest}, idx, allColumns)=> {
                            const _itemType = rest?.type;
                            //TODO: check the styles for paddings...?
                            return {
                                ...rest,
                                className: `${_itemType !== 'groupbox' ? 'py-2 px-2' : ''} ${className}`,
                                content: fields.map((_field, idx, allColumns)=>{
                                    return getField(formFieldProps, errors, initialValues, {..._field}, i, itemNamePrefix);
                                }),
                            };
                        })}
              />
          </InfoBlock>
        )
    }

    if (item.type === 'gridBox') {
        const gridTemplateColumns = +item?.gridTemplateColumns > 0 ? item?.gridTemplateColumns : 1;
        const gridStyles = item?.gridStyles ?? {};

        return (
          <GridContentBox key={formFieldProps.key || `grid-content-box-${item.type}-${i}`}
                          data-grid-template-columns={gridTemplateColumns}
                          style={gridStyles}
          >
              {item?.content?.map((contentItem, i, arr) => {
                  return getField(formFieldProps, errors, initialValues, {...contentItem}, i, itemNamePrefix);
              })}
          </GridContentBox>
        )
    }


    return <TextInput {...formFieldProps} />
}
